import { Handle, Position } from 'reactflow';
import { NodeProps } from 'reactflow';
import { Phase } from '../../configLookup/components/Props';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styles from "../configInfo.module.css";

function PhaseNode({ data }: NodeProps<Phase>) {
    let phaseName = ' ';

    if(data.headerHtml === null || data.headerHtml === ''){
        phaseName = data.name
    } else {
        phaseName = data.headerHtml.replace(/<\/?[^>]+(>|$)/g, "");
    }

    if(phaseName.length > 75) {
        phaseName = phaseName.slice(0, 75 - phaseName.length)
        phaseName += '...'
    }
    
    return (
        <div>
            <Handle type='target' position={Position.Top} isConnectable={false}/>
                <div className={data.visibilityCriteria ? styles.redBorder : undefined}>
                    <Card className={styles.phaseNode}>
                        <CardContent>
                            <Typography variant='h5'><b>{phaseName}</b></Typography>
                            <Typography variant='h6'>Ordinal: {data.ordinal}</Typography>
                        </CardContent>
                    </Card>
                    <Handle type='source' position={Position.Bottom} isConnectable={false}/>
                </div>
        </div>
    )
}

export default PhaseNode;